import axios from '../axios';
import { buildBranchResetPasswordUrl } from '../ApiUrl';

/**
 * POST `/BranchResetPassword?token=<token>` — public route (no JWT middleware).
 *
 * - Token is only in the query string (matches Mongo `resetPasswordToken`).
 * - Body must be JSON: `{ password, retype_password }` (must match each other; server re-checks).
 * - Many outcomes use HTTP 200 with `{ success, CustomMessage }` (e.g. mismatch, invalid token,
 *   token expired, or success with `Password update successfully!`).
 */
export const branchResetPasswordAPI = async (token, payload) => {
  try {
    const url = buildBranchResetPasswordUrl(token);
    const response = await axios.post(
      url,
      {
        password: payload.password,
        retype_password: payload.retype_password,
      },
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );
    return response;
  } catch (error) {
    console.log('branchResetPasswordAPI catch block', error);
    return { hasError: true, error };
  }
};
